export interface Chip {
  id: number | string;
  label: string;
}
